import styled from "styled-components";

export const Skills = styled.div`
color: white;
font-size: 20px;
display: flex;
position: relative;
justify-content: center;
`
